import {
  getItem,
  removeItem,
  removeItemsByPrefix,
  setItem,
} from "@/utils/local-storage";

const PREFIX = "genai-accepted";

export const isGenAiAccepted = (acceptanceScopeId: string, taskNoticeId: string) =>
  getItem(PREFIX, `${acceptanceScopeId}:${taskNoticeId}`, (v) => v) === "true";

export const setGenAiAccepted = (acceptanceScopeId: string, taskNoticeId: string) =>
  setItem(PREFIX, `${acceptanceScopeId}:${taskNoticeId}`, "true");

export const removeGenAiAcceptance = (acceptanceScopeId: string, taskNoticeId: string) =>
  removeItem(PREFIX, `${acceptanceScopeId}:${taskNoticeId}`);

export const clearStaleAcceptance = (
  acceptanceScopeId: string,
  currentTaskNoticeId: string
) => {
  const currentKey = `${PREFIX}:${acceptanceScopeId}:${currentTaskNoticeId}`;
  removeItemsByPrefix(`${PREFIX}:${acceptanceScopeId}:`, currentKey);
};
